/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

/** @module components/product-card */
import baustein from "baustein";
import environment from "web/script/modules/environment";
import productClickMixin from "./mixins/product-click-mixin";
import analytics from "web/script/analytics/analytics";
import userProfiler from "web/script/modules/userprofiler";
import SaveForLaterSignupPrompt from "web/script/components/save-for-later-signup-prompt";
import SaveForLaterButton from "web/script/components/save-for-later-button";
import { languageIsEnglish } from "web/script/modules/language";
import history from "web/script/utils/history";

const IMAGE_CLICK_CLASSES = [".product-card__image-link"];
const DESCRIPTION_CLICK_CLASSES = [".product-card__short-description"];
export const SIGNUP_SELECTOR = ".product-card__save-for-later-signup-prompt";
export const SHORT_DESCRIPTION_SELECTOR = ".product-card__short-description-name";
export const AFFILIATE_SELECTOR = ".product-card__affiliate";

/**
 * The current product card component is only the beginning
 * More functionality incoming.
 * @constructor
 * @alias module:components/product-card
 * @extends module:baustein
 */
export default baustein.register(
    "product-card",
    /** @lends module:components/product-card.prototype */
    {
        mixins: [productClickMixin],

        defaultOptions: {
            newTabEnabled: false,
            overlayEnabled: false,
            productSlug: null,
            productId: null,
            productUid: null,
            productGender: null,
            reason: null,
            inStock: true,
            hasTooltip: false,
            linkId: null,
            useOverlayOnMobile: false
        },

        setupEvents(add) {
            add("click", SIGNUP_SELECTOR, this.onAnonSaveForLater);
            add("click", SHORT_DESCRIPTION_SELECTOR, this.onClickShortDescription);
            add("click", AFFILIATE_SELECTOR, this.onClickAffiliateRetailer);
        },

        onInsert() {
            if (!languageIsEnglish()) {
                // Don't render save for later button or signup prompt in i18n MVPs
                return;
            }

            this.renderOnlySaveForLater();
        },

        renderOnlySaveForLater() {
            const container = this.el.querySelector(".product-card__details");
            if (!container) {
                return;
            }
            const isWishListCard = this.el.classList.contains("wishlist-card");
            if (userProfiler.isLoggedIn()) {
                if (!this.findComponent("save-for-later-button") && !isWishListCard) {
                    const saveForLaterButton = this.getSaveForLaterButton();
                    saveForLaterButton.classList.add("product-card__save-for-later");
                    container.insertBefore(saveForLaterButton, container.firstElementChild);
                }
            } else if (!this.el.querySelector(".product-card__save-for-later-signup-prompt")) {
                const saveForLaterSignupPrompt = this.getSaveForLaterSignupPrompt();
                saveForLaterSignupPrompt.classList.add("product-card__save-for-later");
                container.insertBefore(saveForLaterSignupPrompt, container.firstElementChild);
            }
        },

        getSaveForLaterSignupPrompt() {
            const enableTooltip = environment.get("s4lFeedTooltip");
            const tooltipAdded = environment.get("s4lFeedTooltipAdded");

            if (enableTooltip && !tooltipAdded) {
                this.hasTooltip = true;
                environment.set({ s4lFeedTooltipAdded: true });
            }
            const prompt = new SaveForLaterSignupPrompt({
                has_tooltip: this.hasTooltip,
                productId: this.options.productId,
                productSlug: this.options.productSlug,
                productGender: this.options.productGender
            });
            const wrapper = document.createElement("span");
            wrapper.className = "product-card__save-for-later-signup-prompt";
            prompt.appendTo(wrapper);

            return wrapper;
        },

        getSaveForLaterButton() {
            const button = new SaveForLaterButton({
                isLoveIcon: true,
                productId: this.options.productId
            });
            const wrapper = document.createElement("span");
            button.appendTo(wrapper);

            return wrapper;
        },

        onAnonSaveForLater() {
            analytics.event("save_for_later", "add_item", "product_card");
            this.emit("productCardInteraction");
        },

        getClickOverlayClasses() {
            return IMAGE_CLICK_CLASSES.concat(DESCRIPTION_CLICK_CLASSES);
        },

        getClickRedirectClasses() {
            return [];
        },

        enable() {
            this.el.classList.remove("product-card--disabled");
        },

        disable() {
            this.el.classList.add("product-card--disabled");
        },

        onClickShortDescription() {
            analytics.event("product_card", "short description");
            this.emit("productCardInteraction");
        },

        onClickAffiliateRetailer() {
            analytics.event("product_card", "retailer");
            this.emit("productCardInteraction");
        },

        async sendAnalytics() {
            if (!this.options.algoliaMetadata) {
                return;
            }

            const productCards = document.querySelectorAll(".product-card");
            let position = [...productCards].indexOf(this.el) + 1;

            // pagination will have `page` query params, infinite scroll page however, will not,
            // this handles both use cases nicely
            const currentPage = parseInt(history.getCurrentQueryParams().get("page")) || 1;
            position += (currentPage - 1) * 42;

            // we need to "subtract a minute's worth of milliseconds" to make sure we're not in
            // the future, which makes the servers sad
            const timestamp = Date.now() - 60 * 1000;

            const data = {
                events: [
                    {
                        eventType: "click",
                        eventName: "click on product",
                        timestamp: timestamp,
                        index: this.options.algoliaMetadata.index,
                        userToken: analytics.getDeviceUid(),
                        objectIDs: [this.options.linkId.toString()],
                        queryID: this.options.algoliaMetadata.query_id,
                        positions: [position]
                    }
                ]
            };

            await fetch("https://insights.algolia.io/1/events", {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "X-Algolia-Api-Key": environment.get("algoliaApiKey"),
                    "X-Algolia-Application-Id": environment.get("algoliaApplicationId")
                },
                body: JSON.stringify(data)
            });
        }
    }
);

